// /**
//  * First we will load all of this project's JavaScript dependencies which
//  * includes Vue and other libraries. It is a great starting point when
//  * building robust, powerful web applications using Vue and Laravel.
//  */

window.Vue = require('vue');

import {
    attachVueComponent,
    getUrlParameter,
    genericAlert,
} from './utils/utils';
import Paginate from 'vuejs-paginate';

// *
//  * The following block of code may be used to automatically register your
//  * Vue components. It will recursively scan this directory for the Vue
//  * components and automatically register them with their "basename".
//  *
//  * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>

// // const files = require.context('./', true, /\.vue$/i)
// // files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))


// /**
//  * Next, we will create a fresh Vue application instance and attach it to
//  * the page. Then, you may begin adding components to this application
//  * or customize the JavaScript scaffolding to fit your unique needs.
//  */

// const app = new Vue({
//     el: '#app_body'
// });


// Setup vue
const EventBus = new Vue();
const AsyncPost = require('./plugins/vue.asyncpost.js').default;

Vue.use(AsyncPost);

var routes = require('./routes').default;
Object.defineProperties(Vue.prototype, {
    $csrf: {
        get: function () {
            return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        }
    },
    $bus: {
        get: function () {
            return EventBus
        }
    },
    $redirect: {
        get: function () {
            return (link) => window.top.location.href = link;
        }
    },
    $routes: {
        get: function (r) {
            return routes;
        },
        set: function (r) {
            return routes[r];
        }
    }
});

// Attach all components to #id selector
var AddCardDialogComponent = Vue.component('add-card-dialog-component', require('./components/AddCardDialogComponent.vue').default);
var UpdateContactDetailsComponent = Vue.component('update-contact-details-component', require('./components/UpdateContactDetails.vue').default);
var UpdateProfileInfoDetailsComponent = Vue.component('update-profile-info-details-component', require('./components/UpdateProfileInfoDetails.vue').default);
var ResetPinDialogComponent = Vue.component('reset-pin-dialog-component', require('./components/ResetPinDialogComponent.vue').default);
var ConfirmationResetPinDialogComponent = Vue.component('confirmation-reset-pin-dialog-component', require('./components/ConfirmationResetPinDialogComponent.vue').default);
var ChangePasswordDetailComponent = Vue.component('change-password-detail-component', require('./components/ChangePasswordDetail.vue').default);
var PartnerChangePasswordDetailComponent = Vue.component('partner_change-password-detail-component', require('./components/PartnerChangePasswordDetail.vue').default);
var ChangePinComponent = Vue.component('change-pin-component', require('./components/ChangePinComponent.vue').default);
var ForgotPasswordDialogComponent = Vue.component('forgot-password-dialog-compontent', require('./components/ForgotPasswordDialogComponent.vue').default);
var ConvertBPointsDialogComponent = Vue.component('convert-bpoints-dialog-component', require('./components/ConvertBPointsDialogComponent.vue').default);
var PrepaidTopupDialogComponent = Vue.component('prepaid-topup-dialog-component', require('./components/PrepaidTopupDialogComponent.vue').default);
var PartnerItemComponent = Vue.component('partner-item-component', require('./components/PartnerItemComponent.vue').default);
var InlineDropdownSelectorComponent = Vue.component('inline-dropdown-selector-component', require('./components/InlineDropdownSelectorComponent.vue').default);
var CardDropdownSelectorComponent = Vue.component('card-dropdown-selector-component', require('./components/CardDropdownSelectorComponent.vue').default);
var PartnerOfferAdPreviewComponent = Vue.component('partner-offer-ad-preview-component', require('./components/PartnerOfferAdPreviewComponent.vue').default);
var PaymentSummaryComponent = Vue.component('payment-summary-component', require('./components/PaymentSummaryComponent.vue').default);
var MailBoxListComponent = Vue.component('mail-box-list-component', require('./components/MailBoxListComponent.vue').default);
var NotificationListComponent = Vue.component('notification-list-component', require('./components/NotificationListComponent.vue').default);
var CreateCampaignComponent = Vue.component('create-campaign-component', require('./components/CreateCampaignDialogComponent.vue').default);
var PasswordInputComponent = Vue.component('password-input-component', require('./components/PasswordInputComponent.vue').default);
var EditCampaignComponent = Vue.component('edit-campaign-component', require('./components/EditCampaignCollectionComponent.vue').default);

Vue.component('paginate', Paginate)

attachVueComponent(AddCardDialogComponent, '#vue_add_card_dialog');
attachVueComponent(UpdateContactDetailsComponent, '#vue_update_contact_details');
attachVueComponent(UpdateProfileInfoDetailsComponent, '#vue_update_profile_info_details');
attachVueComponent(ResetPinDialogComponent, '#vue_reset_pin_dialog');
attachVueComponent(ConfirmationResetPinDialogComponent, '#vue_confirmation_reset_pin_dialog');
attachVueComponent(ChangePasswordDetailComponent, '#vue_change_password_detail');
attachVueComponent(PartnerChangePasswordDetailComponent, '#vue_partner_change_password_detail');
attachVueComponent(ChangePinComponent, '#vue_change_pin_dialog');
attachVueComponent(ConvertBPointsDialogComponent, '#vue_convert_bpoints_dialog');
attachVueComponent(PrepaidTopupDialogComponent, '#vue_prepaid_topup_dialog');
attachVueComponent(PartnerItemComponent, '#vue_partner_item');
attachVueComponent(CardDropdownSelectorComponent, '#vue_card_dropdown_selector');
attachVueComponent(ForgotPasswordDialogComponent, '#vue_forgot_password_dialog');
attachVueComponent(PartnerOfferAdPreviewComponent, '#vue_partner_offer_ad_preview_component');

// For transfer points dialog, multiple dropdown in one dialog
attachVueComponent(CardDropdownSelectorComponent, '#vue_card_dropdown_selector_transferPointsFrom');
attachVueComponent(CardDropdownSelectorComponent, '#vue_card_dropdown_selector_transferPointsTo');

// For transaction history, multiple dropdown in one page
attachVueComponent(InlineDropdownSelectorComponent, '#vue_inline_dropdown_selector_filterType');
attachVueComponent(InlineDropdownSelectorComponent, '#vue_inline_dropdown_selector_cards');

// For partner dashboard, multiple dropdown in one page
attachVueComponent(InlineDropdownSelectorComponent, '#vue_inline_dropdown_selector_filterDateSummary');
attachVueComponent(InlineDropdownSelectorComponent, '#vue_inline_dropdown_selector_filterProducts');

// For partner manae promos, multiple dropdown in one page
// attachVueComponent(InlineDropdownSelectorComponent, '#vue_inline_dropdown_selector_filterType'); -- redundant
attachVueComponent(InlineDropdownSelectorComponent, '#vue_inline_dropdown_selector_filterStatus');

attachVueComponent(PaymentSummaryComponent, '#vue_payment_summary');

//inbox
attachVueComponent(MailBoxListComponent, '#vue_mail_box_list_component');
attachVueComponent(NotificationListComponent, '#vue_notification_list_component');

//campaign
attachVueComponent(CreateCampaignComponent, '#vue_create_dialog_component');
attachVueComponent(EditCampaignComponent, '#vue_edit_collection_component');

attachVueComponent(PasswordInputComponent, '#vue_password_input');


require('./plugins/jquery.faded_slick.js');
require('./plugins/jquery.faded_slick_alt.js');
require('./plugins/jquery.redeemables_slider.js');
require('./plugins/jquery.birthdaypick.js');

// Check login modal
if (getUrlParameter('showlogin')) {
    $('#loginModal').modal('show');
}

$('#forgot_password_button').on('click', () => {
    $('#loginModal').modal('hide');
    $('#forgotPasswordDialog').modal('show');
});

// Automatically scroll to document element if hash is available
if (window.location.hash != '') {
    var hash = window.location.hash;
    var $el = $(hash);
    if ($el && $el.offset()) {
        $(document).scrollTop($el.offset().top);
    }
}

$(() => {
    // All hashed links shouldnt jump to top
    $('a[href="#"]').on('click', (e) => e.preventDefault());
});



// Globalize these stuff to window
window.getUrlParameter = getUrlParameter;
window.genericAlert = genericAlert;
